import FormatDate from './FormatDate'

export const FormComment = ({ ...props }) => {
  const commentAuthor = props.comment.author.full_name
  const commentDateFormatted = FormatDate(props.comment.created_at)
  const commentEmail = props.comment.author.email
  const comment = props.comment.comment
  return (
    <div key={props.key}>
      <div>
        <p style={{ marginBottom: 0, fontSize: 13 }}>{commentAuthor}</p>
        <p style={{ marginBottom: 10, fontSize: 13 }}>{commentEmail}</p>
      </div>
      <p style={{ marginRight: 5, marginLeft: 5, fontSize: 16 }}>{comment}</p>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <p style={{ fontSize: 13 }}>{commentDateFormatted}</p>
      </div>
      <hr></hr>
    </div>
  )
}

export default FormComment
